const serviceType = {
    FETCH_SERVICES_START: 'FETCH_SERVICES_START',
    SET_SERVICES: 'SET_SERVICES',
    ADD_SERVICE: 'ADD_SERVICE',
    ADD_SERVICE_START: 'ADD_SERVICE_START'
};

export default serviceType;
